<template>
  <div v-if="loading" class="flex h-full justify-center items-center">
    <loading-spinner diameter="64px"/>
  </div>

  <div v-else class="m-8 bg-white shadow-md p-6 min-h-[85vh]" :class="{ ar: $ctx.locale == 'ar' }">
    <h1 class="text-2xl font-bold text-blue-900 mb-6">{{ t('zeissCardSettings') }}</h1>

    <alert-badge
        isDanger
        :title="error.title"
        :body="error.body"
        @dismissed="
        () => {
          error.title = ''
          error.body = ''
        }
      "
    />

    <option-list
        :title="t('practitioner')"
        :model-value="settings.practitioners"
        :saving="saving"
        @update="(v: string[]) => save({...settings, practitioners: v})"
    />

    <option-list
        class="mt-10"
        :title="t('lensType')"
        :model-value="settings.lensTypes"
        :saving="saving"
        @update="(v: string[]) => save({...settings, lensTypes: v})"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import {useI18n} from 'vue-i18n'

import ZeissCard, {zeissCardI18nMessages, ZeissCardSettings} from '@/models/customer/ZeissCard'

import LoadingSpinner from '@/components/LoadingSpinner.vue'
import AlertBadge from '@/components/AlertBadge.vue'
import OptionList from '@/views/examinations/zeissCards/ZeissCardOptionList.vue'

export default defineComponent({
  name: 'zeiss-card-settings',

  components: {
    LoadingSpinner,
    AlertBadge,
    OptionList
  },

  setup() {
    const {t} = useI18n({
      messages: {
        en: {...zeissCardI18nMessages.en},
        ar: {...zeissCardI18nMessages.ar}
      }
    })

    return {t}
  },

  data() {
    return {
      loading: true,
      settings: {practitioners: [], lensTypes: []} as ZeissCardSettings,
      error: {title: '', body: ''},
      saving: false
    }
  },

  async beforeMount() {
    try {
      this.settings = await this.$http.get<ZeissCardSettings>(ZeissCard.SETTINGS_ENDPOINT)
    } catch (err) {
      const error = err as {title: string; body: string}
      this.error.title = error.title
      this.error.body = error.body
    } finally {
      this.loading = false
    }
  },

  methods: {
    async save(next: ZeissCardSettings) {
      this.saving = true
      try {
        this.settings = await this.$http.put<ZeissCardSettings>(ZeissCard.SETTINGS_ENDPOINT, next)
        this.$alertModal.showSuccess({title: this.t('settingsSaved'), body: ''})
      } catch (err) {
        const error = err as {title: string; body: string}
        this.error.title = error.title
        this.error.body = error.body
      } finally {
        this.saving = false
      }
    }
  }
})
</script>
